import React, { useEffect, useState } from "react";
import AdminUi from "./AdminUi";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import {
  useDeleteAdminMutation,
  useEditAdminMutation,
  useGetAdminsQuery,
} from "../../store/Api/admins";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function Admin() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [deleteAdmin] = useDeleteAdminMutation();
  const [updateAdmin] = useEditAdminMutation();
  const { data: rrb } = useGetRrbQuery({});
  const [filtersId, setFiltersId] = useState({
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [selectData, setSelectData] = useState({
    rrb: [],
  });
  //   const data = [
  //     {
  //       engine: "Trident",
  //       browser: "Internet Explorer 4.0",
  //       platform: "Win 95+",
  //       version: "4",
  //       grade: "X",
  //     },
  //     {
  //       engine: "Trident",
  //       browser: "Internet Explorer 5.0",
  //       platform: "Win 95+",
  //       version: "5",
  //       grade: "C",
  //     },
  //     {
  //       engine: "Trident",
  //       browser: "Internet Explorer 5.5",
  //       platform: "Win 95+",
  //       version: "5.5",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Trident",
  //       browser: "Internet Explorer 6",
  //       platform: "Win 98+",
  //       version: "6",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Trident",
  //       browser: "Internet Explorer 7",
  //       platform: "Win XP SP2+",
  //       version: "7",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Trident",
  //       browser: "AOL browser (AOL desktop)",
  //       platform: "Win XP",
  //       version: "6",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Firefox 1.0",
  //       platform: "Win 98+ / OSX.2+",
  //       version: "1.7",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Firefox 1.5",
  //       platform: "Win 98+ / OSX.2+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Firefox 2.0",
  //       platform: "Win 98+ / OSX.2+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Firefox 3.0",
  //       platform: "Win 2k+ / OSX.3+",
  //       version: "1.9",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Camino 1.0",
  //       platform: "OSX.2+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Camino 1.5",
  //       platform: "OSX.3+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Netscape 7.2",
  //       platform: "Win 95+ / Mac OS 8.6-9.2",
  //       version: "1.7",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Netscape Browser 8",
  //       platform: "Win 98SE+",
  //       version: "1.7",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Netscape Navigator 9",
  //       platform: "Win 98+ / OSX.2+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.0",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.1",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.1",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.2",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.2",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.3",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.3",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.4",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.4",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.5",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.5",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.6",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "1.6",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.7",
  //       platform: "Win 98+ / OSX.1+",
  //       version: "1.7",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Mozilla 1.8",
  //       platform: "Win 98+ / OSX.1+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Seamonkey 1.1",
  //       platform: "Win 98+ / OSX.2+",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Gecko",
  //       browser: "Epiphany 2.20",
  //       platform: "Gnome",
  //       version: "1.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "Safari 1.2",
  //       platform: "OSX.3",
  //       version: "125.5",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "Safari 1.3",
  //       platform: "OSX.3",
  //       version: "312.8",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "Safari 2.0",
  //       platform: "OSX.4+",
  //       version: "419.3",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "Safari 3.0",
  //       platform: "OSX.4+",
  //       version: "522.1",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "OmniWeb 5.5",
  //       platform: "OSX.4+",
  //       version: "420",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "iPod Touch / iPhone",
  //       platform: "iPod",
  //       version: "420.1",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Webkit",
  //       browser: "S60",
  //       platform: "S60",
  //       version: "413",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 7.0",
  //       platform: "Win 95+ / OSX.1+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 7.5",
  //       platform: "Win 95+ / OSX.2+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 8.0",
  //       platform: "Win 95+ / OSX.2+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 8.5",
  //       platform: "Win 95+ / OSX.2+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 9.0",
  //       platform: "Win 95+ / OSX.3+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 9.2",
  //       platform: "Win 88+ / OSX.3+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera 9.5",
  //       platform: "Win 88+ / OSX.3+",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Opera for Wii",
  //       platform: "Wii",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Nokia N800",
  //       platform: "N800",
  //       version: "-",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Presto",
  //       browser: "Nintendo DS browser",
  //       platform: "Nintendo DS",
  //       version: "8.5",
  //       grade: "C/A",
  //     },
  //     {
  //       engine: "KHTML",
  //       browser: "Konqueror 3.1",
  //       platform: "KDE 3.1",
  //       version: "3.1",
  //       grade: "C",
  //     },
  //     {
  //       engine: "KHTML",
  //       browser: "Konqueror 3.3",
  //       platform: "KDE 3.3",
  //       version: "3.3",
  //       grade: "A",
  //     },
  //     {
  //       engine: "KHTML",
  //       browser: "Konqueror 3.5",
  //       platform: "KDE 3.5",
  //       version: "3.5",
  //       grade: "A",
  //     },
  //     {
  //       engine: "Tasman",
  //       browser: "Internet Explorer 4.5",
  //       platform: "Mac OS 8-9",
  //       version: "-",
  //       grade: "X",
  //     },
  //     {
  //       engine: "Tasman",
  //       browser: "Internet Explorer 5.1",
  //       platform: "Mac OS 7.6-9",
  //       version: "1",
  //       grade: "C",
  //     },
  //     // Add more entries if necessary
  //   ];
  const { data, isFetching, isLoading, refetch } = useGetAdminsQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
    rrb_id: filtersId?.rrbId,
  });
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);

  useEffect(() => {
    if (filtersId?.rrbId) {
      refetch();
    }
  }, [filtersId]);
  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
    });
  }, [rrb]);
  const onUpdate = async (row) => {
    // navigate(`/update-admin/${row?.id}`, { state: { row } });
    navigate(`/update-admin`, { state: { row } });
    // try {
    //   const response = await updateAdmin({ id: userId, status: newstatus });
    //   if (response?.data?.success) {
    //     refetch(); // Refresh the user list after updating
    //   }
    // } catch (error) {
    //   console.error(error, "Error updating user status");
    // }
  };
  const deleteAdminFn = async () => {
    try {
      const response = await deleteAdmin({ id: deleteId });
      if (response?.data?.success) {
        // Call refetch to refresh the user list
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    { title: "First Name", dataKey: "firstname" },
    { title: "Last Name", dataKey: "lastname" },
    { title: "Designation", dataKey: "designation" },
    { title: "Phone Number", dataKey: "phone_number" },
    ...(decodedToken?.role === 3 || decodedToken?.role === 4
      ? [{ title: "Role", render: (_, row) => (
        <span>{row?.role == 1? "RRB Admin" :row?.role == 4 ? "Nodal Admin" :row?.role == 5 ?  "ECA Admin" :"-"} </span>
      ) }]
      : []),
    ...(decodedToken?.role === 3 || decodedToken?.role === 4
      ? [{ title: "RRB", dataKey: "rrb", isObject: true, objectKey: "name" }]
      : []),
    
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          {/* <button className="border-0 bg-transparent">
            <i class="fas fa-eye text-primary"></i>
          </button> */}
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => onUpdate(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            data-toggle="modal"
            data-target="#modal-danger"
            onClick={() => setDeleteId(row?.id)}
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];
  const removeFilter = () => {
    setFiltersId({
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    });
    refetch();
    setSelectData({
      rrb: rrb?.data?.data,
    });
  };

  const handleAddAdmin = () => {
    navigate("/create-admin");
  }
  
  return (
    <Layout>
      <AdminUi
        columns={columns}
        data={data?.data?.users || []}
        totalRecords={data?.data?.totalItems}
        onUpdate={onUpdate}
        loading={isLoading}
        tableQaury={tableQaury}
        deleteAdminFn={deleteAdminFn}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        selectData={selectData}
        setFiltersId={setFiltersId}
        setSelectData={setSelectData}
        filtersId={filtersId}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        toast={toast}
        handleAddAdmin={handleAddAdmin}
      />
    </Layout>
  );
}

export default Admin;
